<app-spinner [loading]="spinnerService.loading$ | async" id="spinner" />
<div *ngIf="!_stillProcessing" class="flip-assessment-component">
  <div class="flip-assessment-header">
    <app-header-bar
      (routerLinkClick)="showConfirmationDialog()"
      *ngIf="_dateOfBirth != undefined || _dateOfBirth != null"
      [age]="_age"
      [dob]="_dateOfBirth"
      [showButton]="false"
      [showClientDetails]="false"
      [title]="_clientName"
      id="header"
    />
  </div>
  <!-- Client Information -->
  <div class="dashboard-side-card-container">
    <app-client-information
      [attributes]="_clientInformationAttributes"
      [isVertialOrientation]="true"
      [title]="_clientInformationTitle"
      [urlDisplayText]="_clientInformationDisplayText"
      [url]="_clientInformationUrl"
      id="client-information"
      subtitle=""
    />
  </div>
  <!-- Sub-Menu -->
  <app-sub-menu
    (navigateBackClick)="previousRoute()"
    [clientId]="clientId"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [showBackButton]="true"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [totalReviews]="_totalReviews"
  />
  <div class="flip-assessment-page-layout">
    <div class="flip-assessment-page-left">
      <div class="flip-assessment-page-row">
        <div class="flip-assessment-main-body">
          <app-primary-card #primaryCardComponent height="630px" size="small">
            <div class="flip-assessment-main-card">
              <div class="flip-assessment-logo-section">
                <span class="flip-assessment-logo">
                  <app-flip-logo />
                </span>
              </div>
              <span class="flip-assessment-date-picker">
                <app-datepicker
                  [control]="_clientForm.controls['assessmentDate']"
                  [errorText]="getAssessmentErrorText()"
                  date="{{ _flipAssessmentDataDto?.assessmentDate }}"
                  id="assessment-date"
                  [label]="'Assessment Date' | translate"
                  placeholder="Assessment Date (DD/MM/YYYY)"
                  required="true"
                />
              </span>
            </div>
            <div class="flip-assessment-main-heading-1">
              {{ _currentFlipAssessmentGroup?.name }}
            </div>
            <div class="flip-assessment-content-1">
              <div class="flip-assessment-mat-h2">
                {{ _currItem?.assessmentItem?.itemNumber }}
              </div>
              <div class="flip-assessment-content-2">
                <div class="flip-assessment-left-text">
                  <h1>{{ _currItem?.assessmentItem?.name }}</h1>
                  <div class="flip-assessment-mat-body-strong">
                    {{ _currItem?.assessmentItem?.description }}
                  </div>
                </div>
                <span class="flip-assessment-buttons">
                  <div class="accent-flip-button">
                    <app-flip-button
                      (onClick)="recordActivity(false)"
                      [isDisabled]="_ceilingMet"
                      kind="accent"
                    />
                  </div>
                  <div class="primary-flip-button">
                    <app-flip-button
                      (onClick)="recordActivity(true)"
                      [isDisabled]="_ceilingMet"
                      kind="primary"
                    />
                  </div>
                </span>
              </div>
            </div>
            <div class="flip-assessment-help-tip">
              <app-help-tip
                [title]="_helpTipTitle"
                [value]="_currItem?.assessmentItem?.helpTip"
              ></app-help-tip>
            </div>
          </app-primary-card>
        </div>
      </div>
      <div class="flip-assessment-page-row-2">
        <div class="flip-assessment-processing-buttons">
          <div class="flip-assessment-lower-left-area">
            <app-link-button
              (click)="showConfirmationDialog()"
              color="accent"
              type="button"
              >{{ 'Cancel Assessment' | translate }}
            </app-link-button>
          </div>
          <div class="flip-assessment-lower-middle-area">
            <span class="flip-assessment-progress">
              <h3 [textContent]="getAssessmentText() | translate">
                {{ getAssessmentText() | translate }}
              </h3>
            </span>
            <span class="flip-assessment-action-button">
              <app-action-button
                (onClick)="submit()"
                [hidden]="_hideFlipAssessmentActionButton"
                [isDisabled]="!_ceilingMet"
                color="primary"
                id="submit-button"
                kind="filled"
                size="wide"
                >{{ 'Save & Submit' | translate }}
              </app-action-button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="flip-assessment-page-right">
      <div class="flip-assessment-side-card">
        <app-primary-card size="tiny">
          <app-flip-assessment-side-card
            #flipAssessmentSideCardComponent
            (editClicked)="handleEditClicked($event)"
            *ngIf="_isChildVisible"
            [flipAssessmentGroups]="_flipAssessmentDataDto?.groups"
            [scrollIndex]="_scrollIndex"
          />
        </app-primary-card>
      </div>
      <div class="flip-assessment-notes-section">
        <app-notes-side-card
          [length]="maxLength"
          [textAreaControl]="_clientForm?.controls['textArea']"
          class="notes-side-card"
        />
      </div>
    </div>
  </div>
</div>
